import React from "react"
import { TIMINGS, ANIMATION } from "../config/animation"
import "./contact-us.scss"
import ContactForm from "../pages/contact-us"
import Modal from "./modal"

const contactUs = props => {
  const { hubSpotForm } = props
  return (
    <section className="contact-us">
      <div className="centre contact-us__content">
        <div
          data-sal={ANIMATION.effect}
          data-sal-delay={TIMINGS.fast}
          data-sal-easing={ANIMATION.ease}
          data-sal-duration={ANIMATION.duration}
        >
          <h2>
            Ready to launch? <span>Let's talk.</span>
          </h2>
        </div>
        <div
          data-sal={ANIMATION.effect}
          data-sal-delay={TIMINGS.medium}
          data-sal-easing={ANIMATION.ease}
          data-sal-duration={ANIMATION.duration}
        >
          <div
            className="nav__item button contact__button"
            onClick={props.displayModal}
          >
            Contact Us
          </div>

          <Modal
            show={props.showModal}
            showHideModal={props.displayModal}
            showHideModalOnClickOutSide={props.showHideModalOnClickOutSide}
          >
            <ContactForm hubSpotForm={hubSpotForm} />
          </Modal>
        </div>
      </div>
    </section>
  )
}

export default contactUs
